interface MarqueeItemData {
  ref: () => HTMLElement;
  width: number;
  offsetX: number;
}

function getItemData(itemRefs: (() => HTMLElement)[]) {
  return itemRefs.map((itemRef) => {
    const width = itemRef().offsetWidth;
    const data = {
      ref: itemRef,
      width: width,
      offsetX: 0, // We'll use this to "teleport" items
    };
    itemRef().style.transform = `translate3d(0, 0, 0)`;
    return data;
  });
}

function containsFocusVisible(el: HTMLElement) {
  const activeElement = document.activeElement;

  // 1. Check if the active element is a descendant of the container (or the container itself)
  const isWithinContainer = el.contains(activeElement);
  if (!isWithinContainer) return false;

  // 2. Check if the active element currently matches the :focus-visible pseudo-class
  if (activeElement) return activeElement.matches(":focus-visible");
  return false;
}

function focusDidLeave(e: FocusEvent, el: HTMLElement) {
  return (
    !e.relatedTarget ||
    (e.relatedTarget instanceof Node && !el.contains(e.relatedTarget))
  );
}

export {
  getItemData,
  containsFocusVisible,
  focusDidLeave,
  type MarqueeItemData,
};
